module.exports = __webpack_public_path__ + "static/media/disc_results.3bfe6f98.png";